import React, { useState } from "react";
import { SimpleSelect1 } from "../SimpleSelect/SimpleSelect1";
import Button from "../Button/Button";
import { DataPicker } from "../DataPicker/DataPicker";
import { InputField1 } from "../InputField1/InputField1";
import {
  useGetDepartementList,
  useGetLeaveReq,
  useInsertLeaveReq,
} from "../../hooks/useManagement";
import { formatDate } from "../../utils/formatDate";
import { MiladiToShamsi, ShamsiToMiladi } from "../../utils/Miladi_To_Shamsi";
import Loading from "../Loadings/LoadingTable";
import { Table } from "../Table/Table";
const initvalue = {
  department_id: "",
  description: "",
  start_date: "",
  start_hours: "",
  end_date: "",
  end_hours: "",
};

const LeaveRequest = () => {
  const [form, setForm] = useState(initvalue);
  const [Search, setSearch] = useState("");
  const { data: departement } = useGetDepartementList();
  const { mutateAsync: insertReq } = useInsertLeaveReq();

  const { data: leaveReqList, isLoading } = useGetLeaveReq();
  const Departements = departement?.data?.Departments;
  const DepartementOption = Departements?.map((dep) => {
    return {
      value: dep.IdDepartment,
      label: dep.NameDepartment,
    };
  });

  const handleInsertReq = async (datom) => {
    await insertReq(datom).then(() => setForm(initvalue));
  };
  const RollCallHeader = [
    "شماره",
    "توضیحات",
    "تاریخ",
    "وضعیت درخواست",
    "نظر سرپرست",
    "وضعیت برای سرپرست",
    "نظر مدیر",
    "وضعیت برای مدیر",
  ];
  const items = leaveReqList?.data?.data?.map((item, index) => {
    return (
      <tr key={index}>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {index + 1}
          </span>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            <span>{item?.Description}</span>
          </span>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {`از تاریخ ${MiladiToShamsi(item?.StartDate)} ساعت ${
              item?.StartHours
            } تا تاریخ ${MiladiToShamsi(item?.EndDate)} ساعت ${item?.EndHours}`}
          </span>
        </td>

        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            <Button
              small="fit-content"
              bgColor={item?.main_status?.color}
              color="#fff"
            >
              {item?.main_status?.title}
            </Button>
          </span>
        </td>

        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {item?.DescriptionResponsible
              ? item?.DescriptionResponsible
              : "نامشخص"}
          </span>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            <span className={`text-muted fw-bold text-muted d-block fs-7`}>
              <Button
                small="fit-content"
                bgColor={item?.responsible_status?.color}
                color="#fff"
              >
                {item?.responsible_status?.title}
              </Button>
            </span>
          </span>
        </td>

        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {item?.DescriptionAdmin ? item?.DescriptionAdmin : "نامشخص"}
          </span>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            <Button
              bgColor={item?.admin_status?.color}
              color="#fff"
              small="fit-content"
            >
              {item?.admin_status?.title}
            </Button>
          </span>
        </td>
      </tr>
    );
  });
  return (
    <>
      <div className="leave-req">
        <div className="header">فرم درخواست مرخصی</div>
        <div className="req-body">
          <div className="row">
            <div className="col-lg-4 col-md-6 col-12 mb-3">
              <SimpleSelect1
                label="دپارتمان"
                res={DepartementOption}
                onChange={(e) => setForm({ ...form, department_id: e.value })}
              />
            </div>
            <div className="col-lg-4 col-md-6 col-12 mb-3">
              <InputField1
                label="توضیحات"
                onChange={(e) =>
                  setForm({ ...form, description: e.target.value })
                }
              />
            </div>
            <div className="col-lg-4 col-md-6 col-12 mb-3">
              <DataPicker
                onChange={(e) =>
                  setForm({
                    ...form,
                    start_date: ShamsiToMiladi(formatDate(e)),
                  })
                }
                label="تاریخ شروع مرخصی"
              />
            </div>
            <div className="col-lg-4 col-md-6 col-12 mb-3">
              <InputField1
                label="ساعت شروع مرخصی"
                type="time"
                onChange={(e) =>
                  setForm({ ...form, start_hours: e.target.value })
                }
              />
            </div>
            <div className="col-lg-4 col-md-6 col-12">
              <DataPicker
                label="تاریخ پایان مرخصی"
                onChange={(e) =>
                  setForm({
                    ...form,
                    end_date: ShamsiToMiladi(formatDate(e)),
                  })
                }
              />
            </div>
            <div className="col-lg-4 col-md-6 col-12">
              <InputField1
                label="ساعت پایان مرخصی"
                type="time"
                onChange={(e) =>
                  setForm({ ...form, end_hours: e.target.value })
                }
              />
            </div>
            <div className="col-12">
              <Button
                bgColor="#009ef7"
                color="#fff"
                small="fit-content"
                className="p-2 px-4"
                onclick={() => handleInsertReq(form)}
              >
                ثبت
              </Button>
            </div>
          </div>
        </div>
      </div>
      <Table
        className="mt-3"
        setSearch={setSearch}
        headerTitle={RollCallHeader}
        items={!isLoading ? items : <Loading />}
        title={`لیست درخواست مرخصی`}
      />
    </>
  );
};

export default LeaveRequest;
